import { create } from "../../../common/utils/zustand_state_manager";
import { useAuditorService } from "./use_services";
import { IAuditorRepository } from "../../../features/auditoria/domain/repositories/auditor_repository";
import { AuditorRepository } from "../../../features/auditoria/data/repositories/auditor_repository";


//useAuditorRepositories

type State = {
  auditorRepository: IAuditorRepository,
};

export const useAuditorRepositories = create<State>((set, get) => {
  const { auditorService } = useAuditorService.getState();
  return ({
    auditorRepository: new AuditorRepository(auditorService),
  });
});